document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-gift-card-recipient-form]').forEach((wrapper) => {
    const checkbox = wrapper.querySelector('[data-recipient-checkbox]');
    const fieldsWrapper = wrapper.querySelector('[data-recipient-fields]');
    const emailInput = wrapper.querySelector('[data-recipient-email]');
    const nameInput = wrapper.querySelector('[data-recipient-name]');
    const messageInput = wrapper.querySelector('[data-recipient-message]');
    const sendOnInput = wrapper.querySelector('[data-recipient-send-on]');
    const hiddenFlag = wrapper.querySelector('[data-recipient-hidden-flag]');

    if (!checkbox) return;

    const today = new Date().toISOString().split('T')[0];
    sendOnInput.setAttribute('min', today);

    const toggleFields = () => {
      const checked = checkbox.checked;
      fieldsWrapper.hidden = !checked;

      [emailInput, nameInput, messageInput, sendOnInput, hiddenFlag].forEach((input) => {
        input.disabled = !checked;
      });

      emailInput.required = checked;
    };

    checkbox.addEventListener('change', toggleFields);
    toggleFields();
  });
});